import React from 'react';
import ThumbOverlayDefault from '@wix/da-ds/pkg/thumbs/ThumbOverlayDefault';
import DeviationMediaService from '../../../../utils/DeviationMediaService';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
import { getSource, isGifDeviation, isVideoDeviation } from '../../../_helpers';
import { useDeviationBlockType } from '../../hooks/useDeviationBlockType';
import DeviationThumbStatusIndicators from '../DeviationThumbIndicators';
function getMediaType(deviation) {
    if (isVideoDeviation(deviation)) {
        return 'video';
    }
    if (isGifDeviation(deviation)) {
        return 'gif';
    }
}
function getDuration(deviation) {
    const videoFile = getSource(DeviationMediaService.getMediaByType(deviation, 'video'));
    return videoFile === null || videoFile === void 0 ? void 0 : videoFile.duration;
}
const DeviationThumbOverlayDefault = ({ deviation, width, height, isFaved, hasCommentedOn, children, className })=>{
    const blockType = useDeviationBlockType(deviation);
    const { showPermanentEngagementIcon, showMediaIndicators } = useOverlayContext(deviation);
    return /*#__PURE__*/ React.createElement(ThumbOverlayDefault, {
        width: width,
        height: height,
        isFaved: showPermanentEngagementIcon && isFaved,
        isCommented: showPermanentEngagementIcon && hasCommentedOn,
        statusIndicators: !blockType && /*#__PURE__*/ React.createElement(DeviationThumbStatusIndicators, {
            deviation: deviation
        }),
        mediaIndicator: showMediaIndicators && !blockType ? getMediaType(deviation) : undefined,
        duration: getDuration(deviation),
        className: className
    }, children);
};
DeviationThumbOverlayDefault.displayName = 'DeviationThumbOverlayDefault';
export default DeviationThumbOverlayDefault;
